module.exports = __webpack_public_path__ + "static/media/paisleys-04.8ca94d28.png";